import { Warning } from '@mui/icons-material'
import { Grid, Typography } from '@mui/material'

import classes from './index.styles'

const NumberItem = ({ value, isAlerting }: { value: string; isAlerting: boolean }) => {
  const ariaLabel = value || 'Unknown'

  return (
    <Grid container={true} sx={classes.textValueContainer}>
      <Typography variant="body1" aria-label={ariaLabel}>
        {value || '--'}
      </Typography>
      {isAlerting && <Warning sx={classes.statusItemWarningIcon} />}
    </Grid>
  )
}

export default NumberItem
